


































































































import { Component, Prop, Watch } from "vue-property-decorator"
import Super from "@/pv4-super-class"
import Pagination from "@/components/Pagination.vue"

import { attempt, isError } from "lodash"
import flatten, { unflatten } from "flat"

@Component({
  components: { editor: require("vue2-ace-editor"), Pagination }
})
export default class DataStoreEditor extends Super {
  @Prop({ required: false, default: "" }) value: any
  textValue: any = null

  flatData: any[] = []
  unflatData: any = {}

  currentPage = 1
  itemsPerPage = 7

  modalIsOpen = false

  /**
   * Runs when component is created.
   */
  created() {
    this.copyValueToTextValue()
    this.flatData = this.flattenedData
  }

  get flattenedData() {
    let json: any = flatten(JSON.parse(this.textValue))
    let array: any[] = []
    for (var key of Object.keys(json)) {
      let item = { key: key, value: json[key] }
      array.push(item)
    }
    return array
  }

  unflattenedData() {
    let array: string[] = []
    for (var key of Object.keys(this.flatData)) {
      let obejctKey = this.flatData[key].key
      let objectValue = this.checkTypeOf(this.flatData[key].value)
      let item = `"${obejctKey}": ${objectValue}`
      array.push(item)
    }
    this.textValue = JSON.stringify(
      unflatten(JSON.parse(`{${array.toString()}}`)),
      null,
      "\t"
    )
  }

  checkTypeOf(value: any) {
    console.log(value)
    if (typeof value === "number") {
      return Number(value)
    } else if (typeof value === "boolean") {
      return Boolean(value)
    } else if (value == null) {
      return null
    } else {
      return `"${value}"`
    }
  }

  /**
   * Runs when 'value' changes
   */
  @Watch("value", { immediate: true })
  watchValue() {
    this.copyValueToTextValue()
  }

  copyValueToTextValue() {
    this.textValue = JSON.stringify(this.value, null, "\t")
  }

  editorInit(edit) {
    require("brace/ext/language_tools")
    require("brace/mode/json")
    require("brace/theme/chrome")
    edit.renderer.setPadding(10)
    edit.renderer.setScrollMargin(10)
  }

  select() {
    const json = attempt(() => JSON.parse(this.textValue))
    if (isError(json)) {
      this.displayError(new Error(`Not valid JSON: ${json}`))
      return
    }
    this.$emit("input", json)
    this.$emit("change", this.textValue)
    this.modalIsOpen = false
  }

  cancel() {
    this.$emit("input", this.value)
    this.$emit("change", this.value)
    this.copyValueToTextValue()
    this.modalIsOpen = false
  }
}
